export default __webpack_public_path__ + "static/img_main_pc-07c782c700166988a683516ef45e4054.png";